import { setLightness, darken, shade } from 'polished';
import { DefaultTheme } from "styled-components";

const MAIN_THEME: DefaultTheme = {
    containers: {
        main: {
            backgroundColor: '#f4f4f6',
        },
        cards: {
            backgroundColor: '#fff',
        }
    },
    colors: {
        primary: {
            main: '#452470',
            hover: '#BF76AE',
            text: '#fff',
        },
        secondary: {
            main: '#ED6969',
            hover: '#EB1536',
            text: '#fff',
        },
        success: {
            main: '#452470',
            hover: '#BF76AE',
            text: '#fff',
        },
        error: {
            main: '#c53030',
            hover: shade(0.2, '#c53030'),
            text: '#fff',
        },
        track: {
            main: '#CC1FDB',
            hover: shade(0.2, '#CC1FDB'),
            text: '#fff',
        },
        bootcamp: {
            main: '#E5105D',
            hover: shade(0.2, '#E5105D'),
            text: '#fff',
        },
        acceleration: {
            main: '#17E0BE',
            hover: shade(0.2, '#17E0BE'),
            text: '#fff',
        },
        hired: {
            main: '#B68F53',
            hover: shade(0.2, '#B68F53'),
            text: '#fff',
        },
        candidateNotInterview: {
            main: '#D5A2B8',
            hover: '#EB1536',
            text: '#fff',
        },
        candidateDenyJobOffer: {
            main: '#F24725',
            hover: '#EB1536',
            text: '#fff',
        },
        candidateHired: {
            main: '#2AA789',
            hover: '#39949E',
            text: '#fff',
        },
        candidateNotApproved: {
            main: '#DA0163',
            hover: '#EB1536',
            text: '#fff',
        },
        primaryPurple: {
            main: '#9D4FAA',
            hover: '#b072bb',
            text: '#FFF'
        },
        primaryBlue: {
            main: '#024872',
            hover: '#346c8e',
            text: '#FFF'
        },
        secondaryBlue: {
            main: '#9ABBCF',
            hover: '#aec8d8',
            text: '#FFF'
        },
        gray900: {
            main: '#212121',
            hover: '#424242',
            text: '#FFF'
        },
        gray400: {
            main: '#BDBDBD',
            hover: '#E0E0E0',
            text: '#FFF'
        },
        white: {
            main: '#FFF',
            hover: '#FFF',
            text: '#000'
        },
        denim: {
			main: "#3F4350",
			hover: setLightness(.5, '#3F4350'),
			text: '#fff'
		},
        npsRateColor1: {
            main: '#F94E59',
            hover: darken(.3, '#F94E59'),
            text: '#fff'
        },
        npsRateColor2: {
            main: '#FF8B47',
            hover: darken(.3, '#FF8B47'),
            text: '#fff'
        },
        npsRateColor3: {
            main: '#F3CD35',
            hover: darken(.3, '#F3CD35'),
            text: '#fff'
        },
        npsRateColor4: {
            main: '#9FDF71',
            hover: darken(.3, '#9FDF71'),
            text: '#fff'
        },
        npsRateColor5: {
            main: '#05BC6A',
            hover: darken(.3, '#05BC6A'),
            text: '#fff'
        }
    },
    typography: {
        strong: {
            color: '#0b0f21'
        },
        regular: {
            color: '#858b8d'
        },
        primary: {
            color: '#452470'
        }
    }
};

export default MAIN_THEME;

